module.exports = __webpack_public_path__ + "static/media/syrine.082721e7.JPG";